export default {"src":"/_next/static/media/Notion_Logo.0c1d0376.svg","height":32,"width":112,"blurWidth":0,"blurHeight":0};